import barba from "@barba/core";

import { batch } from "./batchScroll"
import { replaceContent } from "./utils";

export default class Navigation {
  currentBatch = null;
  constructor({ menu, callback, leaveCallback }) {
    this.menu = menu
    this.checkParts();
    this.currentBatch = new batch({ container: document.body.querySelector(`[data-barba="container"]`) })
    barba.init({
      // debug: true,
      // preventRunning: true,
      // sync: true,
      prevent: function ({ event, href }) {
          if (event.type === 'click' && href === window.location.href) {
            event.preventDefault();
            event.stopPropagation();
            if (menu.isOpen) {
              menu.close();
            } else {
              gsap.to(document.body.querySelector(`[data-barba="container"]`), { duration: 1, scrollTo: 0 });
            }
            return true;
         } 
          return (
            href &&
            (href.includes("/wp-content/uploads/") || href.includes("/wp-admin/"))
            ) || document.body.classList.contains("error404");
        
      },
      requestError: (trigger, action, url, response) => {
        if (action === "click" && response && response.status === 404) {
        } else {
        console.warn("requestError", trigger, action, url, response);
        }
      },
      transitions: [
        {
          name: 'default-transition',
          leave(data) {
            this.currentBatch?.dispose();
            leaveCallback();
            if (menu.isOpen) {
              gsap.set(data.current.container, {
                opacity: 0
              });
              return true
            } else {
              return gsap.to(data.current.container, {
                // duration: 3,
                opacity: 0
              });
            }
          },
          enter({ current, next }) {
            const { container } = next
            this.currentBatch = new batch({ container })
            
            const timeline = new gsap.timeline({
              onStart: () => {
                callback(next.container);
              },
              onComplete: () => {
                replaceContent(next, ".wp-block-omnicom-site-menu");
                replaceContent(next, ".main-home-link");
                menu.refresh();
              }
            })
            if (menu.isOpen) {
              timeline.add(menu.close(),'a');
            }
            
            timeline.from(next.container, {
              // duration: 3,
              opacity: 0
            },'a');

            
            return timeline
          }
        }
      ]
    });
  }

  checkParts() {
    let adminBar = document.body.querySelector("#wpadminbar");
    if (adminBar) {
      barba.hooks.beforeEnter(({ current, next }) => {
        if (current.container) {
          replaceContent(next, "#wpadminbar");
        }
      });
    }
  }
}
